"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const WorkItemRecordings = (props) => {
    var _a, _b, _c, _d, _e, _f;
    const { draftType, recordings, matchedRecordings } = props;
    const recordingsToUse = draftType ? recordings : matchedRecordings;
    const recordingsCount = draftType ? recordings.length : matchedRecordings.count;
    const recordingsTitle = draftType
        ? (recordings === null || recordings === void 0 ? void 0 : recordings.length) && ((_a = recordings[0]) === null || _a === void 0 ? void 0 : _a.title)
        : ((_b = matchedRecordings.recordings) === null || _b === void 0 ? void 0 : _b.length) && ((_c = matchedRecordings.recordings[0]) === null || _c === void 0 ? void 0 : _c.recordingTitle);
    const artistTitle = draftType
        ? (recordings === null || recordings === void 0 ? void 0 : recordings.length) && ((_d = recordings[0]) === null || _d === void 0 ? void 0 : _d.artistName)
        : ((_e = matchedRecordings.recordings) === null || _e === void 0 ? void 0 : _e.length) && ((_f = matchedRecordings.recordings[0]) === null || _f === void 0 ? void 0 : _f.recordingDisplayArtistName);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", null,
            react_1.default.createElement("p", { className: 'small-2' },
                "Recordings (",
                recordingsToUse && recordingsCount ? recordingsCount : 0,
                ")"),
            recordingsToUse && recordingsCount ? react_1.default.createElement("p", { className: 'small-2 bold' }, recordingsTitle) : null),
        react_1.default.createElement("div", null,
            react_1.default.createElement("p", { className: 'small-2' },
                "Artists (",
                recordingsToUse && recordingsCount ? recordingsCount : 0,
                ")"),
            recordingsToUse && recordingsCount ? react_1.default.createElement("p", { className: 'small-2 bold' }, artistTitle) : null)));
};
exports.default = WorkItemRecordings;
